import actionTypes from './actionTypes';
import type { IAgencyOption, INamedRef, IStateOption } from '../sharedTypes';
import type { ILoadAgenciesPayload, ILoadEnginesPayload, ILoadUnitsPayload, IPageResult } from './types';

const actions = {
  loadAgenciesRequest: (payload: ILoadAgenciesPayload) => ({
    type: actionTypes.LOAD_AGENCIES_REQUEST,
    payload,
  }),
  loadAgenciesSuccess: (payload: IPageResult<IAgencyOption>) => ({
    type: actionTypes.LOAD_AGENCIES_SUCCESS,
    payload,
  }),
  loadAgenciesError: (append = false) => ({ type: actionTypes.LOAD_AGENCIES_ERROR, payload: { append } }),
  loadEnginesRequest: (payload: ILoadEnginesPayload) => ({
    type: actionTypes.LOAD_ENGINES_REQUEST,
    payload,
  }),
  loadEnginesSuccess: (records: INamedRef[]) => ({ type: actionTypes.LOAD_ENGINES_SUCCESS, payload: { records } }),
  loadEnginesError: () => ({ type: actionTypes.LOAD_ENGINES_ERROR }),
  loadUnitsRequest: (payload: ILoadUnitsPayload) => ({ type: actionTypes.LOAD_UNITS_REQUEST, payload }),
  loadUnitsSuccess: (payload: IPageResult<INamedRef>) => ({
    type: actionTypes.LOAD_UNITS_SUCCESS,
    payload,
  }),
  loadUnitsError: (append = false) => ({ type: actionTypes.LOAD_UNITS_ERROR, payload: { append } }),
  loadStatesRequest: () => ({ type: actionTypes.LOAD_STATES_REQUEST }),
  loadStatesSuccess: (records: IStateOption[]) => ({ type: actionTypes.LOAD_STATES_SUCCESS, payload: { records } }),
  loadStatesError: () => ({ type: actionTypes.LOAD_STATES_ERROR }),
  clearStore: () => ({ type: actionTypes.CLEAR_STORE }),
};

export default actions;
